/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/addressbook';
const RESOURCE_PAGE_FACADE = '/contacts';
const RESOURCE_PAGE_ACTION = '/entryandaddress';
/**
 * update order item via facade
 * @param {*} wcEnv
 *
 */
const updateUserBilling = (
    wcEnv,
    jwtToken,
    contactId,
    billingAddress,
) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = `${RESOURCE_PAGE_FACADE}/${contactId}${RESOURCE_PAGE_ACTION}`;

    return restClient.postFacade(env, resourcePage, jwtToken, billingAddress)
        .then((response) => response);
};

export default updateUserBilling;
